var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showList && _vm.showList.length)?_c('div',{staticClass:"barrage-container"},[_c('div',{staticClass:"content-wrap"},_vm._l((_vm.showList),function(row,index){return _c('div',{key:index,class:[
        'channel',
        'animation-' + row.list.length,
        'channel-' + (index + 1)
      ]},_vm._l((row.list),function(item,idx){return _c('span',{key:idx,staticClass:"barrage-item"},[_vm._v(" "+_vm._s(item)+" ")])}),0)}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }